import IconColorWallet from '@/components/icons/IconColorWallet'
import { useWalletSelector } from '@/contexts/WalletSelectorContext'
import './ConnectWalletView.css'

export default function ConnectWalletView() {
  const { modal } = useWalletSelector()

  const connectWallet = () => modal.show()
  return (
    <div className="connect-wallet-view">
      <IconColorWallet />
      <div className="connect-wallet-view-discription">
        You must be connected wallet to view this content
      </div>
      <div className="connect-wallet-button" onClick={connectWallet}>
        Connect Wallet
      </div>
    </div>
  )
}
